export default {
    methods: {
        generatePatientAndInsuranceRouteLabel(patient, insurances) {
            try {
                if (patient)  {
                    const { internal_number, name_with_employer, age, date_of_birth, icon_gender, icon_identified_gender } = patient

                    const gender = `<i class="${icon_gender}"></i> / <i class="${icon_identified_gender}"></i>`

                    const patientLabel = `${internal_number} | ${name_with_employer} | ${gender} | ${this.toLocaleDate(date_of_birth)} (${age})`

                    // // Find the primary insurance
                    // const primaryInsurance = insurances.find(insurance => insurance.is_primary)
                    // let insuranceLabel = ''

                    // if (primaryInsurance) {
                    //     const { company, type, number, expiry_date } = primaryInsurance
                    //     const companyName = company?.name || "Unknown Company"
                    //     const planName = type?.name || "Unknown Plan"
                    //     const expiry = this.toLocaleDate(expiry_date)

                    //     insuranceLabel = `| Insurance (${companyName} | ${planName} | ${number} | Exp: ${expiry})`
                    // }

                    // return `${patientLabel} ${insuranceLabel}`
                    return patientLabel
                }

                return ''

            } catch (e) {
                console.error('Error generating label:', e)
            }
        }
    }
}